import React, { useEffect, useState } from "react";
import Base from "../admin_components/Admin_Base";
import { Breadcrumbs, Link, TextField, Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Table, Tbody, Td, Th, Thead, Tr } from "react-super-responsive-table";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import "../CustomerProperty/CustomerRequestedProperty.css";
import authAxios from "../Auth/useAxios";
import Swal from "sweetalert2";
import { ClipLoader } from "react-spinners";

const CustomerRequestedProperty = () => {
  const [recordsPerPage, setRecordsPerPage] = useState(5);
  const [customerProperties, setCustomerProperties] = useState([]);
  const [showEmi, setShowEmi] = useState(false);
  const [emiStartDate, setEmiStartDate] = useState("");
  const [currentEmiProperty, setCurrentEmiProperty] = useState(null);
  const [customers, setCustomers] = useState([]);
  const [selectedEmiMonths, setSelectedEmiMonths] = useState("");
  const [employeeIncentive, setEmployeeIncentive] = useState([]);
  const [selectedEmployeeIncentive, setSelectedEmployeeIncentive] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;

  useEffect(() => {
    incentiveList([]);
  }, []);

  const incentiveList = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/get-all-incentives`
      );

      setEmployeeIncentive(response.data);
      console.log("incentativelist", response.data);
    } catch (error) {
      console.error("Error fetching pending properties:", error);
    }
  };


  const handleUpdateEmi = async (id) => {


    const payload = {
      selectedEmiMonths,
      emiStartDate,
      incentiveId: selectedEmployeeIncentive || null,
    };

    try {
      const response = await authAxios.put(
        `${ADMIN_API_BASE_URL}/main/admin/${id}/update-emi`,
        null,
        { params: payload }
      );


      if (response.status === 200) {
        Swal.fire("Success", "EMI details updated successfully!", "success");
      } else {
        Swal.fire("Error", "Failed to update EMI details.", "error");
      }
    } catch (error) {
      console.error("Error updating EMI details:", error);
      Swal.fire("Error", "Could not update EMI details.", "error");
    }
  };



  useEffect(() => {
    fetchPendingProperties();
  }, []);

  const fetchPendingProperties = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/get-all-customer-properties`
      );
      console.log(response.data);

      const pendingProperties = response.data.filter(
        (property) => property.customerPropertyEnum === "PENDING"
      );

      setCustomerProperties(pendingProperties);
      console.log("pendinglist", response.data);
    } catch (error) {
      console.error("Error fetching pending properties:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateCustomerPropertyStatus = async (id, status) => {
    try {
      const response = await authAxios.put(
        `${ADMIN_API_BASE_URL}/main/admin/${id}/update-status?customerPropertyEnum=${status.toUpperCase()}`
      );

      if (response.status === 200) {
        const updatedTime = new Date().getTime();

        setCustomerProperties((prev) =>
          prev.map((prop) =>
            prop.id === id
              ? { ...prop, customerPropertyEnum: status, updatedTime }
              : prop
          )
        );

        Swal.fire(
          "Updated!",
          `This is moving into ${status} list .`,
          "success"
        );

        setTimeout(() => {
          setCustomerProperties((prev) =>
            prev.filter(
              (prop) =>
                prop.id !== id ||
                new Date().getTime() - prop.updatedTime < 24 * 60 * 60 * 1000
            )
          );
        }, 24 * 60 * 60 * 1000);
      } else {
        Swal.fire("Error!", "Failed to update property status.", "error");
      }
    } catch (error) {
      console.error(
        "Error updating customer property status:",
        error.response?.data || error.message
      );
      Swal.fire("Error!", "Could not update the property status.", "error");
    }
  };




  const handleApprove = async (id) =>
    updateCustomerPropertyStatus(id, "ACTIVE");
  const handleReject = async (id) =>
    updateCustomerPropertyStatus(id, "INACTIVE");



  const handleViewClick = (property) => {
    setCurrentEmiProperty({
      plotCost: property.plots?.plotAmount || 0,
      amountPaid: property.amountPaid || 0,
      totalEmisPaid: property.emiPaid || 0,
      remainingAmount: property.remainingAmount || 0,
      selectedEmiMonths: property.selectedEmiMonths || 0,
      remainingEmis: property.selectedEmiMonths - property.emiPaid || 0,
      emiStartDate: property.emiStartDate?.split("T")[0] || "N/A",
      emiEndDate: property.emiEndDate?.split("T")[0] || "N/A",
      emiAmount: property.emiAmount || 0,
      id: property.id || 0,
    });
    console.log("id", property.id)
    setShowEmi(true);
  };


  const totalPages = Math.ceil(customerProperties.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = customerProperties.slice(startIndex, endIndex);

  console.log("emilist", currentEmiProperty);
  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div
            className="pt-3 mt-5 res_container"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
              className="admin_navigation"
            >
              <Link
                underline="hover"
                color="inherit"
                href="/admin/dashboard"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Dashboard
              </Link>
              <Link
                underline="none"
                color="inherit"
                href="/admin/customer_requested_property"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                CustomerRequestedProperty
              </Link>
            </Breadcrumbs>
          </div>

          <h2 className="text-center fw-bold main_heading">
            Customer Requested Property
          </h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "90%" }} />
          </div>

          <div className="container" style={{ textAlign: "end" }}>
            <TextField
              type="number"
              label="Records per page"
              variant="outlined"
              size="small"
              style={{ width: "150px", marginBottom: "10px" }}
              value={recordsPerPage}
              onChange={(e) => setRecordsPerPage(Number(e.target.value))}
            />

            <Table
              className="customer table"
              style={{ margin: "0 auto", width: "95%" }}
            >
              <Thead
                className="text-white"
                style={{ backgroundColor: "darkslategrey" }}
              >
                <Tr>
                  <Th>S.No</Th>
                  <Th>Customer Name</Th>
                  <Th>Property Name</Th>
                  <Th>Mobile Number</Th>
                  <Th>Passbook No</Th>
                  <Th>Plot Selected</Th>
                  <Th>Plot Direction</Th>
                  <Th>Date of Plot Purchased</Th>
                  <Th>Status</Th>
                  <Th>EMI Details</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paginatedRequests.length === 0 ? (
                  <Tr>
                    <Td colSpan={10} style={{ textAlign: "center", padding: "1rem" }}>
                      No customers found.
                    </Td>
                  </Tr>
                ) : (
                  customerProperties.map((property, index) => (
                    <Tr key={property.id}>
                      <Td>{index + 1}</Td>
                      <Td>{property.customer.customerName}</Td>
                      <Td>{property.customer?.groupName}</Td>
                      <Td>{property.customer?.mobileNumber}</Td>
                      <Td>{property.customer?.passbook}</Td>
                      <Td>{property.plots.plotNumber}</Td>
                      <Td>{property.plots.plotDirection}</Td>
                      <Td>
                        {property.purchaseDate
                          ? property.purchaseDate.split("T")[0]
                          : "N/A"}
                      </Td>
                      <Td style={{ textAlign: "center" }}>
                        {property.customerPropertyEnum === "PENDING" && (
                          <div className="d-flex">
                            <Button
                              style={{
                                backgroundColor: "#098666",
                                color: "white",
                                marginRight: "8px",
                              }}
                              onClick={() => handleApprove(property.id)}
                            >
                              Approve
                            </Button>
                            <Button
                              style={{ backgroundColor: "#cc0000", color: "white" }}
                              onClick={() => handleReject(property.id)}
                            >
                              Reject
                            </Button>
                          </div>
                        )}

                        {property.customerPropertyEnum === "ACTIVE" && (
                          <Button
                            style={{
                              backgroundColor: "#098666",
                              color: "white",
                              display: "block",
                              margin: "0 auto",
                            }}
                          >
                            Approved
                          </Button>
                        )}

                        {property.customerPropertyEnum === "INACTIVE" && (
                          <Button
                            style={{
                              backgroundColor: "#cc0000",
                              color: "white",
                              display: "block",
                              margin: "0 auto",
                            }}
                          >
                            Rejected
                          </Button>
                        )}
                      </Td>

                      <Td>
                        <Button

                          onClick={() => handleViewClick(property)}

                          sx={{
                            backgroundColor: "#098666",
                            color: "white",
                            padding: "10px 20px",
                            fontSize: "10px",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            textTransform: "none",
                            transition: "0.3s",
                            "&:hover": {
                              backgroundColor: "#086655",
                            },
                            "&:active": {
                              transform: "scale(0.95)",
                            },
                          }}
                        >
                          EMI
                        </Button>
                      </Td>
                    </Tr>
                  ))
                )}
              </Tbody>
            </Table>
          </div>


          {/* EMI Modal */}
          <Modal
            show={showEmi}
            onHide={() => setShowEmi(false)}
            className="fullscreen-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title>Customer EMI Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="modal-container">
                {currentEmiProperty ? (
                  <>
                    <Table className="emidetail-table">
                      <Tbody>
                        <Tr>
                          <Td>Cost Of the Plot</Td>
                          <Td>₹{currentEmiProperty.plotCost}</Td>
                        </Tr>
                        <Tr>
                          <Td>Amount Paid Till Now</Td>
                          <Td>₹{Math.round(currentEmiProperty.amountPaid)}</Td>
                        </Tr>
                        <Tr>
                          <Td>Total EMI's Paid</Td>
                          <Td>{currentEmiProperty.totalEmisPaid}</Td>
                        </Tr>
                        <Tr>
                          <Td>Remaining Amount</Td>
                          <Td>₹{Math.round(currentEmiProperty.remainingAmount)}</Td>
                        </Tr>
                        <Tr>
                          <Td>Selected EMI Months</Td>
                          <Td>
                            <input
                              type="number"
                              value={selectedEmiMonths}
                              placeholder={currentEmiProperty.selectedEmiMonths}
                              min="0"
                              max="36"
                              onChange={(e) => setSelectedEmiMonths(Math.min(36, Math.max(0, e.target.value)))}
                              className="emi-input"
                            />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>Remaining EMI's</Td>
                          <Td>{currentEmiProperty.remainingEmis}</Td>
                        </Tr>
                        <Tr>
                          <Td>EMI Start Date</Td>
                          <Td>
                            <input
                              type="date"
                              value={emiStartDate}
                              onChange={(e) => setEmiStartDate(e.target.value)}
                              className="emi-input"
                            />
                          </Td>
                        </Tr>
                        <Tr>
                          <Td>EMI End Date</Td>
                          <Td>{currentEmiProperty.emiEndDate}</Td>
                        </Tr>
                        <Tr>
                          <Td>EMI Amount Monthly</Td>
                          <Td>₹{Math.round(currentEmiProperty.emiAmount)}</Td>
                        </Tr>
                        <Tr>
                          <Td>Employee Incentive</Td>
                          <Td>
                            <select
                              value={selectedEmployeeIncentive}
                              onChange={(e) => setSelectedEmployeeIncentive(e.target.value)}
                              className="emi-input"
                            >
                              <option value="">Select Incentive</option>
                              {employeeIncentive.map((incentive) => (
                                <option key={incentive.id} value={incentive.id}>
                                  {incentive.name}
                                </option>
                              ))}
                            </select>
                          </Td>
                        </Tr>
                      </Tbody>
                    </Table>
                    <div>
                      <Button onClick={() => handleUpdateEmi(currentEmiProperty.id)} variant="contained"
                        sx={{
                          backgroundColor: "#098666",
                          color: "white",
                          padding: "10px 20px",
                          fontSize: "16px",
                          fontWeight: "bold",
                          borderRadius: "8px",
                          textTransform: "none",
                          transition: "0.3s",
                          "&:hover": {
                            backgroundColor: "#086655",
                          },
                          "&:active": {
                            transform: "scale(0.95)",
                          },
                        }}>Update EMI</Button>
                    </div>
                  </>
                ) : (
                  <p>No EMI details available.</p>
                )}
              </div>
            </Modal.Body>
          </Modal>

          <div className="pagination-controls-payment-history">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span className="mx-2">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </>
      )}
    </Base>
  );
};

export default CustomerRequestedProperty;
